export default __webpack_public_path__ + "static/media/PlayH7.f9a3e4da.png";